import { Group } from 'three';

import WebGLSketch from '../_app/cuchillo/3D/WebGLSketch';
import { GetBy } from '../_app/cuchillo/core/Element';
import BoxInitial from './BoxInitial';
import BoxProject from './BoxProject';
import BoxTeam from './BoxTeam';
import BoxManifesto from './BoxManifesto';
import BoxInspiration from './BoxInspiration';

const CLASSES = {
    'initial': BoxInitial,
    'project': BoxProject,
    'team': BoxTeam,
    'manifesto': BoxManifesto,
    'inspiration': BoxInspiration
}

export default class Scene {
    static group = new Group();
    static items = [];
    static bg;

    static running = false;
    static initialized = false;

    static init() {
        WebGLSketch.add(this.group);
        this.init3dItems();
    }

    static start() {
        if (!this.running) this.running = true;

        this.update();
    }

    static stop() {
        if (this.running) this.running = false;
    }

    static add(element) {
        this.group.add(element);
    }

    static remove(element) {
        this.group.remove(element);
    }

    static init3dItems() {
        this.show();

        const boxes = GetBy.selector('#Canvas .__box');
        for (let i = 0; i < boxes.length; i++) {
            const dom = boxes[i];
            const box = new CLASSES[dom.dataset.type](dom);
            this.items.push(box);
            WebGLSketch.add(box);
        }
    }

    static show(cb = () => { }) {
        this.initialized = true;
        cb();
    }

    static hide() { }

    static loop() {
        if (!this.running) return;
        // if (!this.running || !this.initialized) return;
        // this.update();
    }

    static update() {
        for (let i = 0; i < this.items.length; i++) {
            this.items[i].update();
        }
    }

    static resize() {
        for (let i = 0; i < this.items.length; i++) {
            this.items[i].resize();
        }
    }

    static dispose() {
        for (let i = 0; i < this.items.length; i++) {
            this.remove(this.items[i]);
            this.items[i].dispose();
        }

        WebGLSketch.remove(this.group);
        this.group.dispose();
    }
}
